import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NoResultImg from '../assets/images/no_result.gif'
import GRAPHQL_API from 'api/graphql';
import { shuffle } from 'utils/utils';
import Quote from 'components/Quote';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, CircularProgress, Backdrop } from '@material-ui/core';
// import ShuffleIcon from '@material-ui/icons/Shuffle';
// import ACTION_TYPES from 'redux-lib/actions/actions';
// import useDeepCompareEffect from 'use-deep-compare-effect'

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
}

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    justifyContent: {
        justifyContent: 'center'
    },
    reshuffle: {
        textAlign: 'right'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }
}));

const getAccreditationColor = (accreditation) => {
    const result = {
        "Accredited": "#62b44e",
        "Not Accredited but accepts the policy": "#00a4fd",
        "Needs Accommodation Letter": "#f6de02",
        "Not Accredited": "#fc0404"
    }
    return result[accreditation];
}

function NoQuotes(props) {
    return(
        <div className={ `quotes-container-inner` } style={{ textAlign: 'center', padding: 20 }}>
            <img src={ NoResultImg } alt=""/>
            {/* <small>No Quotes to display</small> */}
        </div>
    )
}

function Quotes(props) {

    const classes = useStyles();
    // const [ quotes, setQuotes ] = useState([]);
    // const [ carInsuranceData, setCarInsuranceData ] = useState([]);
    const [ openBackdrop, setOpenBackdrop ] = useState(false)
    const dispatch = useDispatch();
    const states = useSelector(state => {
        return state.globalStates
    })

    const previousQuotes = usePrevious(states.quotes);
    /**
     * Get the vehicle usage.
     * @returns { String } [ PRIVATE | COMMERCIAL | OTHER ] 
     */
    const getUsage = () => {
        let vType = null;
        if( states.vehicle_type ) {
            if( states.vehicle_type.label ) {
                if( states.vehicle_type.label === 'Private' || states.vehicle_type.label === 'Personal Vehicle' ) {
                    vType = 'PRIVATE'; 
                } else if( 
                    states.vehicle_type.label === 'Uber or Grab' ||
                    states.vehicle_type.label === 'forHire' || 
                    states.vehicle_type.label === 'Commercial Vehicle'
                ) {
                    vType = 'COMMERCIAL'; 
                } else if( states.vehicle_type.label === 'Other' ) {
                    vType = 'OTHER'; 
                }
            }
        }
        return vType;
    }

    /**
     * Returns the Pipedrive bank ID.
     * @returns { Number } Bank ID coming from Pipedrive "Mortgagee" Deal Field
     */
    const getBankId = () => {
        let id = null;
        const graphBanks = states.graph_bank_partners;
        const bank = states.bank ? states.bank.label ? states.bank.label : null : null;
        if( graphBanks && bank ) {
            id = _.find(graphBanks, [ 'bank_name', bank ]);
        }
        return !id ? null : id.title;
    }

    /**
     * Returns the GraphQL get_car_insurance_quote_request args.
     * @type {object}
     * @returns The query object args for get_car_insurance_quote_request
     */
    const ciQuery = {
        car_id: states.car_id ? states.car_id : null,
        fair_market_value: states.fmv ? states.fmv * 100 : null,
        bodily_injury_and_property_damage_coverage: states.bipd ? states.bipd * 100 : null,
        personal_accident_coverage: states.pa ? states.pa : null,
        includes_acts_of_nature: states.aon ? states.aon.label === 'With AON' ? true : false : false,
        usage: getUsage(),
        loan_with_bank_id: getBankId(),
    }

    const getQueries = (cancelled) => {
        if( !ciQuery.car_id || !ciQuery.fair_market_value) return;
        getQuotesQuery(ciQuery).then((data) => {
            if( cancelled ) return;
            getQuotes(data);
        });
    }

    useEffect(() => {
        let cancelled = false;
        if( states.car_id || states.car_id !== '' ) {
            getQueries(cancelled)
        }
        return () => {
            cancelled = true;
        }
    }, [ 
        states.car_id, 
        states.fmv,
        states.pa,
        states.bipd,
        states.vehicle_type,
        states.aon,
        states.bank,
        states.reshuffle,
        states.number_of_seats
        // states
    ]) 

     /**
     * Get bank accreditations
     * @param {object} data 
     * @type { object }
     * @returns { object } { accredition, color, accreditation_desc }
     */
    const getAccreditationValues = (carInsurance) => {
        const result = { accreditation: 'No Accreditations', color: '#6e6e6e', accreditation_desc: 'There are no accreditations set for this provider.' };
        if( carInsurance ) {
            const bank = states.bank ? states.bank.label ? states.bank.label : null : null;
            const ci = carInsurance[0];
            if( ci.bank_accreditation && !_.isEmpty( ci.bank_accreditation ) ) {
                if( bank !== 'Not Mortgaged' ) {
                    const findBank = _.find(ci.bank_accreditation, { bank: [ { bank_name: bank } ] });
                    result.accreditation = findBank ? findBank.accreditation : 'Not Accredited';
                    result.color = getAccreditationColor(result.accreditation);
                    result.accreditation_desc = findBank ? findBank.accreditation_short_description : 'Selected bank is not accredited by this provider.';
                }
            }
        }
        return result;
    }

    /**
     * Returns the GrapgQL response data from get_car_insurance_quote_request query.
     * @param {object} data 
     * @type { Array }
     * @returns { Array } The quotes array
     */
    const getQuotes = (data) => {
        const ciReqResponse = data && data.data ? data.data : null;
        let finalRes = [];
        if(ciReqResponse) {
            if(ciReqResponse.get_car_insurance_quote_request && ciReqResponse.get_car_insurance_quote_request.quotes) {
                finalRes = ciReqResponse.get_car_insurance_quote_request.quotes.map((provider) => {
                    return getProviderInfo(provider.provider_id).then((data) => {
                        if( data && data.data ) {
                            if( data.data.get_car_insurance ) {
                                const newQuote = Object.assign({}, provider);
                                newQuote.car_insurance = data.data.get_car_insurance;
                                newQuote.car_type = states.car_type;
                                newQuote.is_accredited = getAccreditationValues(data.data.get_car_insurance);
                                newQuote.number_of_seats = states.number_of_seats;
                                newQuote.vehicle_type = getUsage();
                                return newQuote;
                            }
                        }
                    })
                })
            }
        }
        
        if( finalRes.length > 0 ) {
            Promise.all(finalRes).then( promiseItems => {
                dispatch({
                    type: `UPDATE_QUOTES`,
                    payload: promiseItems
                })
                storeSelectedQuotes(promiseItems);
            })
        } else {
            dispatch({
                type: `UPDATE_QUOTES`,
                payload: finalRes
            })
            storeSelectedQuotes(finalRes);
        }
    }

    /**
     * Returns the quote comparisons
     * @param { Array } finalQuotes 
     * @returns { JSX.Element } Mapped quotes to the Quote Component or NoQoutes if finalQuotes is empty.
     */
    const getQuoteComparisons = ( finalQuotes ) => {
        let result = [];
        const colors = [ '#f19031', '#1a517a', '#84c04e' ];
        if( finalQuotes && finalQuotes.length > 0 ) {
            result = finalQuotes.map((quote, index) => {
                return <Quote key={ `quote-card-${ index }` } data={ quote } index={ index } colorTheme={ colors[index] } quotes={ states.quotes } />
            })
            return result;
        } else {
            return <NoQuotes/>
        }
    }

    const mapSelectedQuotes = (theQuotes = [], provider) => {
        let finalQuotes = [];
        let index = -1;
        if( provider ) {
            const providerMatch = _.find(theQuotes, ['product_name', provider] );
            if( providerMatch ) {
                index = _.findIndex(theQuotes, ['product_name', provider]);
            }
            if( index > -1 ) {

                if(getUsage() === 'COMMERCIAL') {
                    const selectedProvider = theQuotes.splice( index, 1 ); 
                    theQuotes.unshift(selectedProvider[0])
                    finalQuotes = theQuotes;
                } else {
                    if( states.selected_quotes && _.isArray( states.selected_quotes ) && states.selected_quotes.length > 0 ) {
                        if(previousQuotes && previousQuotes.length !== theQuotes.length) {
                            const selectedProvider = theQuotes.splice( index, 1 ); 
                            const quotesBracketing = _.chunk(theQuotes, 2);
                            shuffle(quotesBracketing);
                            if( quotesBracketing[0].length === 1 ) {
                                if( quotesBracketing.length > 1 ) {
                                    const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-1);
                                    quotesBracketing[0].unshift(selectedProvider[0], bufferForOddChunks[0])
                                } else {
                                    quotesBracketing[0].unshift(selectedProvider[0])
                                }
                            } else {
                                quotesBracketing[0].unshift(selectedProvider[0])
                            }
                            finalQuotes = quotesBracketing[0];   
                        } else {
                            states.selected_quotes.forEach((quote, index) => {
                                const match = _.find(theQuotes, ['provider_id', quote.provider_id] );
                                if( match ) {
                                    finalQuotes.push(match);
                                }
                            })
                        }
                    } else {
                        const selectedProvider = theQuotes.splice( index, 1 ); 
                        const quotesBracketing = _.chunk(theQuotes, 2);
                        shuffle(quotesBracketing);
                        if( quotesBracketing[0].length === 1 ) {
                            if( quotesBracketing.length > 1 ) {
                                const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-1);
                                quotesBracketing[0].unshift(selectedProvider[0], bufferForOddChunks[0])
                            } else {
                                quotesBracketing[0].unshift(selectedProvider[0])
                            }
                        } else {
                            quotesBracketing[0].unshift(selectedProvider[0])
                        }
                        finalQuotes = quotesBracketing[0];   
                    }
                }
            } else {

                if( theQuotes.length ) {
                    if(getUsage() === 'COMMERCIAL') {
                        const selectedProvider = theQuotes.splice( index, 1 ); 
                        theQuotes.unshift(selectedProvider[0])
                        finalQuotes = theQuotes;
                    } else {
                        if( states.selected_quotes && _.isArray( states.selected_quotes ) && states.selected_quotes.length > 0 ) {
                            if(previousQuotes && previousQuotes.length !== theQuotes.length) {
                                const quotesBracketing = _.chunk(theQuotes, 3);
                                shuffle(quotesBracketing);
                                if( quotesBracketing[0].length === 1 ) {
                                    if( quotesBracketing.length > 1 ) {
                                        const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-2);
                                        quotesBracketing[0].unshift(bufferForOddChunks[0])
                                    }
                                } else if( quotesBracketing[0].length === 2 ) {
                                    if( quotesBracketing.length > 1 ) {
                                        const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-1);
                                        quotesBracketing[0].unshift(bufferForOddChunks[0])
                                    }
                                }
                                finalQuotes = quotesBracketing[0];
                            } else {
                                states.selected_quotes.forEach((quote, index) => {
                                    const match = _.find(theQuotes, ['provider_id', quote.provider_id] );
                                    if( match ) {
                                        finalQuotes.push(match);
                                    }
                                })
                            }
                        } else {
                            const quotesBracketing = _.chunk(theQuotes, 3);
                            shuffle(quotesBracketing);
                            if( quotesBracketing[0].length === 1 ) {
                                if( quotesBracketing.length > 1 ) {
                                    const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-2);
                                    quotesBracketing[0].unshift(bufferForOddChunks[0])
                                }
                            } else if( quotesBracketing[0].length === 2 ) {
                                if( quotesBracketing.length > 1 ) {
                                    const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-1);
                                    quotesBracketing[0].unshift(bufferForOddChunks[0])
                                }
                            }
                            finalQuotes = quotesBracketing[0];
                        }
                    }
                }

            }
           
        } else {

            // NO PROVIDER LOGIC HERE

            if( theQuotes.length ) {

                if(getUsage() === 'COMMERCIAL') {
                    const selectedProvider = theQuotes.splice( index, 1 ); 
                    theQuotes.unshift(selectedProvider[0])
                    finalQuotes = theQuotes;
                } else {
                    if( states.selected_quotes && _.isArray( states.selected_quotes ) && states.selected_quotes.length > 0 ) {
                        if(previousQuotes && previousQuotes.length !== theQuotes.length) {
                            const quotesBracketing = _.chunk(theQuotes, 3);
                            shuffle(quotesBracketing);
                            if( quotesBracketing[0].length === 1 ) {
                                if( quotesBracketing.length > 1 ) {
                                    const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-2);
                                    quotesBracketing[0].unshift(bufferForOddChunks[0])
                                }
                            } else if( quotesBracketing[0].length === 2 ) {
                                if( quotesBracketing.length > 1 ) {
                                    const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-1);
                                    quotesBracketing[0].unshift(bufferForOddChunks[0])
                                }
                            }
                            finalQuotes = quotesBracketing[0];
                        } else {
                            states.selected_quotes.forEach((quote, index) => {
                                const match = _.find(theQuotes, ['provider_id', quote.provider_id] );
                                if( match ) {
                                    finalQuotes.push(match);
                                }
                            })
                        }
                    } else {
                        const quotesBracketing = _.chunk(theQuotes, 3);
                        shuffle(quotesBracketing);
                        if( quotesBracketing[0].length === 1 ) {
                            if( quotesBracketing.length > 1 ) {
                                const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-2);
                                quotesBracketing[0].unshift(bufferForOddChunks[0])
                            }
                        } else if( quotesBracketing[0].length === 2 ) {
                            if( quotesBracketing.length > 1 ) {
                                const bufferForOddChunks = quotesBracketing.slice(-2)[0].slice(-1);
                                quotesBracketing[0].unshift(bufferForOddChunks[0])
                            }
                        }
                        finalQuotes = quotesBracketing[0];
                    }
                }
            }
            
        }
        return finalQuotes
    }

    const storeSelectedQuotes = (promiseItems) => {
        const theQuotes = _.orderBy(promiseItems, ['total_premium'], ['asc']);
        const provider = states.provider;
        let finalQuotes = [];

        finalQuotes = [ ...mapSelectedQuotes( theQuotes, provider ) ];
        dispatch({
            type: `UPDATE_SELECTED_QUOTES`,
            payload: finalQuotes
        })
        setOpenBackdrop(false)
    }

    /**
     * Render the quotes
     * @returns { JSX.Element } The final mapped Quotes.
     */
    const renderQuotes = () => {
        
        const selectedQuotes = states.selected_quotes;
        const qouteComparisons = getQuoteComparisons(selectedQuotes);
        return qouteComparisons;
        
    }

    // const handleReShuffle = (e) => {
    //     e.preventDefault();
    //     setOpenBackdrop(true)
    //     setTimeout(() => {
    //         dispatch({
    //             type: ACTION_TYPES.UPDATE_RESHUFFLE,
    //             payload: !isNaN(states.reshuffle) ? states.reshuffle + 1 : 0
    //         })
    //     }, 500)
    // }

    return(
        <div className={classes.root}>
            {/* {
                states.quotes && states.quotes.length ? 
                <div className={ classes.reshuffle }>
                    <IconButton
                    style={{ background: '#3f88b1' }}
                    aria-label="re-shuffle"
                    title={ `Re-shuffle` }
                    onClick={handleReShuffle}
                    >
                        <ShuffleIcon style={{ color: '#ffffff' }} />
                    </IconButton>
                </div> : null
            } */}
            <Grid container className={ classes.justifyContent } spacing={3}s style={{ padding: 70 }}>
                { renderQuotes() } 
            </Grid>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

/**
 * Returns the get_car_insurance query Promise
 * @param { String } providerId 
 * @returns { Promise } The get_car_insurance query Promise
 */
const getProviderInfo = (providerId) => {

    const query = `{
        get_car_insurance(provider_id: "${ providerId }") {
          title
          promotional {
            type
            text
          }
          bank_accreditation {
            bank {
              title
              cag_bank_id
              bank_name
            }
            accreditation
            accreditation_short_description
          }
          product_features {
            title
            years_of_casa_eligibility
            maximum_total_sum_insured
            number_of_accredited_repair_shops
            riot_strike_and_malicious_damage_coverage
            riot_strike_and_malicious_damage_coverage_short_description
            roadside_assistance {
              towing_amount
              towing_short_description
              vehicle_removal_crane_services_amount
              vehicle_removal_short_description
              access_to_critical_information
              access_to_critical_information_short_description
              alternative_transport
              alternative_transport_short_description
              overnight_accommodation_amount
              overnight_accommodation_short_description
              emergency_message_relay_service_short_description
              emergency_message_relay_service_short_description
            }
            minor_on_site_repairs {
              battery_boosting
              battery_boosting_short_description
              jumpstart
              jumpstart_short_description
              flat_tire_replacement
              flat_tire_replacement_short_description
              delivery_of_gasoline
              delivery_of_gasoline_short_description
              locksmith
              locksmith_short_description
            }
            authorized_repair_limit
            authorized_repair_limit_short_description
          }
          general_product {
            title
            image {
              url
            }
            provider {
              title
              provider_name
              pros
              cons
            }
            image_alt_text
          }
          rates {
            title
            local_government_tax
            document_stamp_tax
            vat
            rates {
              rate_type
              deductible_fixed
              number_of_waived_deductibles
              number_of_waived_deductibles_short_description
              personal_accident_seats_covered
              personal_accident_cost_per_seat
              personal_accident_coverage_per_seat
            }
          }
        }
    }`

    return GRAPHQL_API.graph(query);
    
}

/**
 * Returns the get_car_insurance_quote_request query Promise
 * @param { object } quoteRequest 
 * @returns { Promise } The get_car_insurance_quote_request query Promise
 */
const getQuotesQuery = (quoteRequest) => {
    const query = `{
        get_car_insurance_quote_request(
          quote_request: {
            car_id: ${ quoteRequest.car_id }
            fair_market_value: ${ quoteRequest.fair_market_value }
            bodily_injury_and_property_damage_coverage: ${ quoteRequest.bodily_injury_and_property_damage_coverage }
            personal_accident_coverage: ${ quoteRequest.personal_accident_coverage }
            includes_acts_of_nature: ${ quoteRequest.includes_acts_of_nature }
            usage: "${ quoteRequest.usage }"
            loan_with_bank_id: ${ quoteRequest.loan_with_bank_id }
          }
        ) {
          quote_request_id
          quotes {
            provider_id
            product_name
            total_premium
            deductible
            taxes {
              document_stamps {
                percentage
                price
              }
              local_government {
                percentage
                price
              }
              vat {
                percentage
                price
              }
            }
            prices {
              own_damage_theft {
                coverage
                price
              }
              act_of_nature {
                coverage
                price
              }
              bodily_injury {
                coverage
                price
              }
              property_damage {
                coverage
                price
              }
              personal_accident {
                coverage
                price
              }
            }
          }
        }
    }`;
    return GRAPHQL_API.graph(query);
}

export default React.memo(Quotes);